var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.3594 12.8379V18.5391C19.3594 18.9914 18.9914 19.3594 18.5391 19.3594H2.46094C2.00862 19.3594 1.64062 18.9914 1.64062 18.5391V12.8379H0V18.5391C0 19.896 1.10398 21 2.46094 21H18.5391C19.896 21 21 19.896 21 18.5391V12.8379H19.3594Z","fill":"black","key":0}),React.createElement("path",{"d":"M14.4374 9.66804L11.3202 12.7852V0H9.67962V12.7852L6.56243 9.66804L5.40234 10.8281L10.4999 15.9257L15.5975 10.8281L14.4374 9.66804Z","fill":"black","key":1})]);
}

Download.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Download;

Download.default = Download;
